export const ADD_TO_CART = 'ADD_TO_CART';
export const DELETE_STORE_FROM_CART = 'DELETE_STORE_FROM_CART';
export const DELETE_PRODUCT_CART = 'DELETE_PRODUCT_CART';
export const DELETE_PRODUCTS_FROM_CART ='DELETE_PRODUCTS_FROM_CART';
export const DELETE_CART ='DELETE_CART';
export const ADD_HISTORY = 'ADD_HISTORY';
export const REMOVE_HISTORY = 'REMOVE_HISTORY';